import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["isAuthenticated", "currentUser"]),
  },
  async mounted() {
    // Check if user is authenticated
    if (!this.isAuthenticated) {
      // Try to check authentication with API
      try {
        const authValid = await this.$store.dispatch('checkAuth');
        if (!authValid) {
          // Redirect to login if not authenticated
          this.$router.push({ 
            name: 'Sign In', 
            query: { redirect: this.$route.fullPath } 
          });
          return;
        }
      } catch (error) {
        console.error('Auth check error:', error);
        // Redirect to login on error
        this.$router.push({ 
          name: 'Sign In', 
          query: { redirect: this.$route.fullPath } 
        });
        return;
      }
    }
  },
};
